import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import s from './H3.module.scss'

function H3({ className, children, bold, muted, inline, ...props }) {
  const classes = classnames(s.h3, className, {
    [s.bold]: bold,
    [s.muted]: muted,
    [s.inline]: inline
  })

  return (
    <div className={classes} role="heading" aria-level="3" {...props}>
      {children}
    </div>
  )
}

H3.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  bold: PropTypes.bool,
  muted: PropTypes.bool,
  inline: PropTypes.bool
}

H3.defaultProps = {
  className: null,
  children: null,
  bold: false,
  muted: false,
  inline: false
}

export default H3
